import React from 'react';

const CommonModal = ({ 
  isOpen, 
  onClose, 
  title, 
  icon,
  children, 
  size = 'lg', 
  className = "",
  showCloseButton = true,
  closeOnOverlay = true 
}) => {
  if (!isOpen) return null;

  const sizeClasses = {
    sm: 'max-w-md',
    md: 'max-w-2xl',
    lg: 'max-w-4xl',
    xl: 'max-w-6xl',
    full: 'max-w-7xl'
  };

  const handleOverlayClick = (e) => {
    if (closeOnOverlay && e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div 
      className="fixed inset-0 backdrop-blur-sm bg-black/20 overflow-y-auto h-full w-full z-50 flex items-center justify-center p-2"
      onClick={handleOverlayClick}
    >
      <div className={`relative w-full ${sizeClasses[size]} bg-white rounded-2xl shadow-2xl border border-gray-100 max-h-[95vh] overflow-y-auto ${className}`}>
        {title && (
          <div className="flex-shrink-0 bg-gradient-to-r from-indigo-600 to-purple-600 px-4 py-2.5 rounded-t-lg z-10">
            <div className="flex items-center justify-between">
              <div className="flex items-center space-x-3">
                {icon && (
                  <div className="w-8 h-8 bg-white/20 rounded-lg flex items-center justify-center">
                    {icon}
                  </div>
                )}
                <h3 className="text-lg font-semibold text-white">
                  {title}
                </h3>
              </div>
              {showCloseButton && (
                <button
                  onClick={onClose}
                  className="w-7 h-7 rounded-lg flex items-center justify-center text-white/80 hover:text-white hover:bg-white/20 transition-all"
                >
                  <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              )}
            </div>
          </div>
        )}

        <div className="p-4">
          {children}
        </div>
      </div>
    </div>
  );
};

export default CommonModal;